<kop-wrapper (onInvalidKop)="this.onKopInvalid()">
    <ng-content [app-bar-menu]>
        <auth-badge></auth-badge>
    </ng-content>
</kop-wrapper>
